import React, { useState, useContext } from "react";
import { RootStoreContext } from "../../store";
import CustomBtn from "../button/CustomBtn";

function CustomSCBG(props) {
  const { TeamStore } = useContext(RootStoreContext);
  const { updateData } = TeamStore;

  const c2e = {
    執行長: "CEO",
    行銷長: "CMO",
    技術長: "CTO",
    財務長: "CFO",
    設計長: "CDO",
  };
  const [buttons, setButtons] = useState(
    props.buttons.map((item) => ({ label: item, value: false }))
  );

  const handleButtonsChange = ({ buttons, setButtons }) => (index) => {
    const newButtonsState = buttons.map((button, i) => {
      return index === i
        ? { label: button.label, value: true }
        : { label: button.label, value: false };
    });
    setButtons(newButtonsState);
    for (let i = 0; i < newButtonsState.length; i++) {
      if (newButtonsState[i].value) {
        updateData("members", {
          title: c2e[newButtonsState[i].label],
          name: props.extraInfo,
        });
        props.onChange(c2e[newButtonsState[i].label]);
      }
    }
  };

  return (
    <div style={{ width: "600px" }}>
      <>
        {buttons.map((button, index) =>
          button.value ? (
            <CustomBtn
              variant="h9"
              key={`${button.label}-${index}`}
              onClick={() => {
                handleButtonsChange({
                  buttons,
                  setButtons,
                })(index);
              }}
              bgcolor="#ECB700"
              borderColor="#ECB700"
              fontcolor="#FFFFFF"
            >
              {button.label}
            </CustomBtn>
          ) : (
            <CustomBtn
              variant="h9"
              key={`${button.label}-${index}`}
              onClick={() => {
                handleButtonsChange({
                  buttons,
                  setButtons,
                })(index);
              }}
              bgcolor="#FFFFFF"
              borderColor="#ECB700"
              fontcolor="#575757"
            >
              {button.label}
            </CustomBtn>
          )
        )}
      </>
    </div>
  );
}

export default CustomSCBG;
